{
  "Clear filters": "Clear filters",
  "no-search-match": "Nothing matched your search.",
  "no-search-match-type": "No {{type}} matched",
  "Edit": "Edit",
  "Resource": "Resource",
  "Content": "Content",
  "All spaces": "All spaces",
  "All providers": "All partners",
  "All types": "All types",
  "All categories": "All categories",
  "All subjects": "All subjects",
  "Resources": "Resources",
  "Type": "All content types",
  "Manually added": "Manually added",
  "userId": "User Id",
  "id": "ID",
  "Licenses": "Licenses",
  "username": "Username",
  "Info": "Info",
  "No matches": "No matches",
  "A page that includes a single learning item.": "A page that includes a single learning item.",
  "Possibility to use all formats below": "Possibility to use all formats below",
  "Upload image(s)": "Upload image(s)",
  "Upload audio file(s)": "Upload audio file(s)",
  "Upload xAPI/HTML5 package": "Upload xAPI/HTML5 package",
  "Upload downloadable item(s)": "Upload downloadable item(s)",
  "Upload or link to video(s)": "Upload or link to video(s)",
  "A lecture, workshop, or presentation": "A lecture, workshop, or presentation",
  "Participants meet virtually": "Participants meet virtually",
  "Participants meet in a physical location": "Participants meet in a physical location",
  "A compilation of learning items of different types, formats, and delivery modes that are completed in a specific order, linked to and built by a 3rd party provider or in Learnifier.": "A compilation of learning items of different types, formats, and delivery modes that are completed in a specific order, linked to and built by a 3rd party provider or in Learnifier.",
  "Multiple learning items of different types, formats, and delivery modes based on a common topic or role, organized in one space. The items do not have to be completed in a specific order.": "Multiple learning items of different types, formats, and delivery modes based on a common topic or role, organized in one space. The items do not have to be completed in a specific order.",
  "view": "View",
  "save": "Save",
  "page": "Page",
  "document": "Document",
  "write-your-content": "Write your content",
  "video": "Video",
  "add-video-url": "Add video URL",
  "close": "Close",
  "add": "Add"
}
